import {
  SET_DATE,
  SET_VIEW,
  NEXT_BUTTON,
  GET_CALENDAR,
  SET_CALENDAR_DATA,
  TOGGLE_MODAL,
  SET_SELECTED_EMPLOYEE,
  SET_SELECTED_SERVICE,
  SET_APPOINTMENT_TIME,
  SET_APPOINTMENT_DATE,
  ADMIN_BOOK_APPOINTMENT,
  ADMIN_BOOKING_HIDE_MESSAGE,
  ADMIN_BOOKING_SHOW_MESSAGE,
  SET_ADMIN_ALL_EMPLOYEE_SELECTED,
  SET_ADMIN_EMPLOYEE_SELECTED,
  SET_SINGLE_SELECTED_EMPLOYEE,
  CHANGE_ADMIN_LOADER,
  SET_CUSTOMER_LIST,
  SET_SELECTED_CUSTOMER,
  SET_MODAL_INITIATOR,
  SET_APPOINTMENT_MESSAGE,
  SET_APPOINTMENT_STATUS,
  EDIT_ADMIN_APPOINTMENT,
  SET_APPOINTMENT_ID,
  SET_CALENDAR_VIEW,
  OPEN_EMPLOYEE_SELECTION,
  SET_MONTHLY_SELECT_EMPLOYEE,
  REMOVE_WORKING_HOURS_EMPLOYEE,
  TOGGLE_CUSTOMER_MODAL,
  CALL_CUSTOMERS_API,
  CALL_CUSTOMERS_API_RESPONSE,
  CHANGE_CUSTOMER_ADD_STATE,
  ADMIN_BOOK_FAIL_RESPONSE,
  ADMIN_BOOK_REQUEST_CLOSE,
  UPDATE_CUSTOMER_LIST,
  ADMIN_BOOK_APPOINTMENT_RESPONSE,
  EDIT_ADMIN_APPOINTMENT_RESPONSE,
  ADMIN_BOOK_LOADER_SHOW,
  ADMIN_BOOK_LOADER_HIDE,
  ADMIN_BOOK_MAIN_LOADER_SHOW,
  ADMIN_BOOK_MAIN_LOADER_HIDE,
  BULK_EMPLOYEE_CALENDER_RESPONSE,
} from "../constants/ActionTypes";

export const setDate = date =>
  //
  ({
    type: SET_DATE,
    payload: date,
  });

export const setView = view =>
  //
  ({
    type: SET_VIEW,
    payload: view,
  });

export const nextButtonClick = () => ({
  type: NEXT_BUTTON,
});

export const getCalendar = payload => ({
  type: GET_CALENDAR,
  payload,
});

export const setCalendarData = payload => ({
  type: SET_CALENDAR_DATA,
  payload,
});

export const toggleModal = payload => ({
  type: TOGGLE_MODAL,
  payload,
});

export const setSelectedEmployee = payload => ({
  type: SET_SELECTED_EMPLOYEE,
  payload,
});

export const setSelectedService = payload => ({
  type: SET_SELECTED_SERVICE,
  payload,
});

export const setAppointmentDate = payload => ({
  type: SET_APPOINTMENT_DATE,
  payload,
});

export const setAppointmentTime = payload => ({
  type: SET_APPOINTMENT_TIME,
  payload,
});

export const adminBookAppointment = payload => ({
  type: ADMIN_BOOK_APPOINTMENT,
  payload,
});

export const editAdminAppointment = payload => ({
  type: EDIT_ADMIN_APPOINTMENT,
  payload,
});

export const setAppointmentId = payload => ({
  type: SET_APPOINTMENT_ID,
  payload,
});

export const hideAppointmentMessage = () => ({
  type: ADMIN_BOOKING_HIDE_MESSAGE,
});

export const showAppointmentMessage = payload => ({
  type: ADMIN_BOOKING_SHOW_MESSAGE,
});
export const selectedAllEmployee = () => ({
  type: SET_ADMIN_ALL_EMPLOYEE_SELECTED,
});

export const selectEmployee = payload => ({
  type: SET_ADMIN_EMPLOYEE_SELECTED,
  payload,
});

export const selectSingleEmployee = payload => ({
  type: SET_SINGLE_SELECTED_EMPLOYEE,
  payload,
});

export const changeAdminLoader = payload => ({
  type: CHANGE_ADMIN_LOADER,
  payload,
});

export const setCustomerList = payload => ({
  type: SET_CUSTOMER_LIST,
  payload,
});

export const updateCustomerList = payload => ({
  type: UPDATE_CUSTOMER_LIST,
  payload,
});

export const setSelectedCustomer = payload => ({
  type: SET_SELECTED_CUSTOMER,
  payload,
});

export const setAppointmentStatus = payload => ({
  type: SET_APPOINTMENT_STATUS,
  payload,
});

export const setAppointmentMessage = payload => ({
  type: SET_APPOINTMENT_MESSAGE,
  payload,
});

export const setModalInitiator = payload => ({
  type: SET_MODAL_INITIATOR,
  payload,
});

export const setCalendarView = payload => ({
  type: SET_CALENDAR_VIEW,
  payload,
});

export const openEmployeeSelectionModal = () => ({
  type: OPEN_EMPLOYEE_SELECTION,
});

export const setMonthlySelectEmployee = payload => ({
  type: SET_MONTHLY_SELECT_EMPLOYEE,
  payload,
});

export const removeWorkingHoursEmployee = payload => ({
  type: REMOVE_WORKING_HOURS_EMPLOYEE,
  payload,
});

export const toggleCustomerModal = payload => ({
  type: TOGGLE_CUSTOMER_MODAL,
  payload,
});

export const callCustomerApi = () => ({
  type: CALL_CUSTOMERS_API,
});

export const callCustomerApiResponse = payload => ({
  type: CALL_CUSTOMERS_API_RESPONSE,
  payload,
});

export const changeCustomerAddState = payload => ({
  type: CHANGE_CUSTOMER_ADD_STATE,
  payload,
});

export const adminBookFailResponse = payload => ({
  type: ADMIN_BOOK_FAIL_RESPONSE,
  payload,
});

export const adminBookRequestClose = payload => ({
  type: ADMIN_BOOK_REQUEST_CLOSE,
  payload,
});

export const adminBookAppointmentResponse = payload => ({
  type: ADMIN_BOOK_APPOINTMENT_RESPONSE,
  payload,
});

export const editAdminAppointmentResponse = payload => ({
  type: EDIT_ADMIN_APPOINTMENT_RESPONSE,
  payload,
});

export const adminBookLoaderShow = () => ({
  type: ADMIN_BOOK_LOADER_SHOW,
});

export const adminBookLoaderHide = () => ({
  type: ADMIN_BOOK_LOADER_HIDE,
});

export const adminBookMainLoaderShow = payload => ({
  type: ADMIN_BOOK_MAIN_LOADER_SHOW,
  payload,
});

export const adminBookMainLoaderHide = payload => ({
  type: ADMIN_BOOK_MAIN_LOADER_HIDE,
  payload,
});

export const bulkEmployeeCalenderResponse = payload => ({
  type: BULK_EMPLOYEE_CALENDER_RESPONSE,
  payload,
});



// WEBPACK FOOTER //
// ./actions/AdminBookAppointment.js